import {
    useBreakpointValue,
    useDisclosure,
    useMediaQuery,
    useRadioGroup,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import * as Yup from "yup";
import * as Constants from "../../constants/Constants";
import { getAddressObject } from "../../helpers/delivery/delivery";
import { isValidObject } from "../../helpers/utils/Utils";
import { GrubPopupErrorHook } from "../../hooks/index";
import {
    getUserDeliveryAddresses,
    saveDeliveryAddressForFutureOrder,
} from "../../modules/home/services/HomeServices";
import GrubToastMessage from "../alert/GrubToastMessage";
import AppContext from "../appcontex/AppContext";

const useHeader = (props) => {
    // hooks
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { error } = GrubPopupErrorHook();
    const { addToast } = GrubToastMessage();
    const isMobile = useBreakpointValue({ base: true, md: false });
    const myContext = useContext(AppContext);
    const [isLarge] = useMediaQuery("(min-width: 660px)");
    const [isMedium] = useMediaQuery("(min-width: 480px)");
    const [isSmall] = useMediaQuery("(max-width: 380px)");

    // constants
    const selectedScheduleOptions = Constants.SCHEDULE_TYPES;
    const options = ["Pickup", "Delivery"];
    // states
    const [isModalOpen, setModalOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(null);
    const [isGiftCardModalOpen, setIsGiftCardModalOpen] = useState(false);
    const [alreadySavedAddresses, setAlreadySavedAddresses] = useState([]);
    const [orderType, setOrderType] = useState(
        props.delivery_pickup[0]?.order_type == "delivery"
            ? "Delivery"
            : "Pickup"
    );
    const [errorMessage, setErrorMessage] = useState("");
    const [isOrderTypeLayout, setIsOrderTypeLayout] = useState(true);
    const [isDeliveryAddress, setIsDeliveryAddress] = useState(false);
    const [address, setAddress] = useState(
        props.delivery_pickup[0]?.order_type == "delivery"
            ? {
                  label: props.delivery_pickup[0].address,
                  value: {
                      description: props.delivery_pickup[0].address,
                  },
              }
            : null
    );
    const [sheduleTypeLayout, setSheduleTypeLayout] = useState(false);
    const [googleDeliveryAddress, setGoogleDeliveryAddress] = useState(
        props.delivery_pickup[0]?.order_type == "delivery"
            ? {
                  address: props.delivery_pickup[0].address,
                  city: props.delivery_pickup[0].city,
                  state: props.delivery_pickup[0].state,
                  zipCode: props.delivery_pickup[0].zipcode,
                  country: props.delivery_pickup[0].country,
                  scheduleOrder: props.delivery_pickup[0].scheduleOrder,
                  DeliveryTime: props.delivery_pickup[0].DeliveryTime,
                  place_id: props.delivery_pickup[0].place_id,
              }
            : null
    );
    const [timeSlot, setTimeSlot] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
    const [selectedScheduleType, setSelectedScheduleType] = useState("asap");
    const [stateData, setStateData] = useState({
        scheduled_type: "asap",
        deliveryTime: "",
        asapTimeSlot: "",
        saveDeliveryAddress: false,
    });
    const [showNewAddressForm, setShowNewAddressForm] = useState(false);
    const [asapTime, setAsapTime] = useState("");
    const [selectedPlaceId, setSelectedPlaceId] = useState(null);
    const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
    const [serverPayload, setServerPayload] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const { getRootProps, getRadioProps } = useRadioGroup(
        {
            name: "framework",
            defaultValue:
                props.delivery_pickup[0]?.order_type === "delivery"
                    ? "Delivery"
                    : "Pickup",
            value: orderType,
            onChange: (e) => {
                let orderTypeValue = e === "Delivery" ? "delivery" : "pickup";
                let isLocationPickup =
                    props.delivery_pickup[0]?.location
                        ?.location_online_order_settings[0]?.is_pickup;
                let isLocationDelivery =
                    props.delivery_pickup[0]?.location
                        ?.location_online_order_settings[0]?.is_delivery;
                let isZipCodeDelivery =
                    props.delivery_pickup[0]?.location
                        ?.location_online_order_settings[0]?.delivery_zips;
                if (
                    orderTypeValue == "delivery" &&
                    (!isLocationDelivery || isZipCodeDelivery.length == 0)
                ) {
                    setOrderType(e);
                    setErrorMessage(
                        "Delivery service is not supported at this location."
                    );
                } else if (orderTypeValue == "pickup" && !isLocationPickup) {
                    setOrderType(e);
                    setErrorMessage(
                        "Pickup service is not supported at this location."
                    );
                } else {
                    setSelectedPlaceId(null);
                    setErrorMessage("");
                    setOrderType(e);
                }
            },
        },
        [isOpen]
    );
    const group = getRootProps();
    const open = Boolean(anchorEl);
    const menuOpen = Boolean(popoverOpen);
    const id = open || menuOpen ? "simple-popover" : undefined;

    const orderInstructionFormik = useFormik(
        {
            initialValues: {
                instruction:
                    props.delivery_pickup[0]?.order_type === "delivery"
                        ? props.order.instruction
                        : "",
            },
            validationSchema: Yup.object({
                instruction: Yup.string().max(
                    255,
                    Constants.VALID_ORDER_INSTRUCTION
                ),
            }),
            onSubmit: (values) => {
                if (
                    null != values.instruction &&
                    undefined != values.instruction &&
                    values.instruction.length <= 255
                ) {
                    props.orderInstruction(values.instruction);
                }
            },
        },
        [isOpen]
    );

    useEffect(() => {
        if (
            isValidObject(props.order.instruction) &&
            props?.order?.instruction?.length > 0
        ) {
            orderInstructionFormik.setFieldValue(
                "instruction",
                props.order.instruction
            );
        } else {
            orderInstructionFormik.setFieldValue("instruction", "");
        }
    }, [isOpen]);

    const handleChangeDeliveryPickup = async () => {
        if (props.payments.length === 0) {
            let addressData= []
            await getUserDeliveryAddresses()
                .then((res) => {
                    if (res.data.flag) {
                        addressData = res.data.data;
                        setAlreadySavedAddresses(res.data.data);
                        setShowNewAddressForm(false);
                    } else {
                        setAlreadySavedAddresses([]);
                        setShowNewAddressForm(true);
                    }
                })
                .catch(() => {
                    setAlreadySavedAddresses([]);
                    setShowNewAddressForm(true);
                });

            const orderType =
                props.delivery_pickup[0]?.order_type === "delivery"
                    ? "Delivery"
                    : "Pickup";
            const address =
                orderType === "Delivery"
                    ? {
                          label: props.delivery_pickup[0].address,
                          value: {
                              description: props.delivery_pickup[0].address,
                          },
                      }
                    : null;
            let isDeliveryAddress =
                props.delivery_pickup[0].order_type == "delivery"
                    ? true
                    : false;
            if (isDeliveryAddress) {
                let addressObject = {
                    address: props.delivery_pickup[0].address,
                    city: props.delivery_pickup[0].city,
                    state: props.delivery_pickup[0].state,
                    zipCode: props.delivery_pickup[0].zipCode,
                    country: props.delivery_pickup[0].country,
                    scheduleOrder: props.delivery_pickup[0].scheduleOrder,
                    DeliveryTime: props.delivery_pickup[0].DeliveryTime,
                    place_id: props.delivery_pickup[0].place_id,
                    postal_code: props.delivery_pickup[0].zipCode,
                };
                setGoogleDeliveryAddress(addressObject);
                let deliveryIndex = addressData.findIndex(item => item.place_id == addressObject?.place_id)
                if(deliveryIndex <= -1){
                    setShowNewAddressForm(true)
                }
            }

            setOrderType(orderType);
            setAddress(address);
            setSelectedScheduleType("asap");
            setSelectedTimeSlot("");
            setErrorMessage("");
            onOpen();
        } else {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
        }
    };

    const handleClick = (event, type) => {
        if (type == "menu") {
            setPopoverOpen(event.currentTarget);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
        setPopoverOpen(null);
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        let token = localStorage.getItem("token");
        if (isValidObject(token)) {
            handleCheckSaveDeliveryAddress();
        }
        setModalOpen(false);
        handleClose();
    };

    const handleMenuClick = (e) => {
        // Close the popover first
        handleClose();
        // Then handle the logout
        props.removeUserCardDetails();
        props.userLogout();
        localStorage.removeItem("token");
        addToast({
            alertStatus: Constants.TOAST_TYPE_SUCESS,
            alertTitle: Constants.TOAST_HEADING_SUCCESS,
            alertDescription: Constants.LOGOUT_SUCCESS,
        });
    };

    const handleOrderHistoryClick = () => {
        // Close the popover first
        handleClose();

        // Then navigate
        props.navigate(
            `/${localStorage.getItem("tenant")}` + Constants.ORDER_HISTORY_PATH
        );
    };

    const handleProfileClick = () => {
        // Close the popover first
        handleClose();
        props.navigate(
            `/${localStorage.getItem("tenant")}` + Constants.PROFILE_PATH
        );
    };

    const handleGiftCardClick = (value) => {
        if (props.payments.length > 0 && value) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
            return;
        }
        setIsGiftCardModalOpen(value);
    };

    const handleSetDelivery = async (val) => {
        if (val == null) {
            setAddress(null);
            setGoogleDeliveryAddress(null);
            return;
        }
        setAddress(val);
        const geocodeObj =
            val && val.value && (await geocodeByPlaceId(val.value.place_id));
        const addressObject =
            geocodeObj && getAddressObject(geocodeObj[0].address_components);
        addressObject.place_id = geocodeObj[0]?.place_id;

        setGoogleDeliveryAddress(addressObject);
        if (val == null) {
            setErrorMessage(Constants.DELIVERY_ADDRESS_REQUIRED);
            return;
        }
        if (addressObject?.address?.trim() == "") {
            setErrorMessage(Constants.DELIVERY_ADDRESS_NOT_FOUND);
            return;
        }
        if (addressObject?.city?.trim() == "") {
            setErrorMessage(Constants.DELIVERY_ADDRESS_CITY_NOT_FOUND);
            return;
        }
        if (addressObject?.state?.trim() == "") {
            setErrorMessage(Constants.DELIVERY_ADDRESS_STATE_NOT_FOUND);
            return;
        }
        if (addressObject?.country?.trim() == "") {
            setErrorMessage(Constants.DELIVERY_ADDRESS_COUNTRY_NOT_FOUND);
            return;
        }
        if (addressObject?.postal_code?.trim() == "") {
            setErrorMessage(Constants.DELIVERY_ADDRESS_ZIPCODE_NOT_FOUND);
            return;
        }
        if (
            isValidObject(addressObject) &&
            isValidObject(addressObject?.address?.trim()) &&
            isValidObject(addressObject?.city?.trim()) &&
            isValidObject(addressObject?.state?.trim()) &&
            isValidObject(addressObject?.country?.trim()) &&
            isValidObject(addressObject?.postal_code?.trim())
        ) {
            checkDeliveryService(addressObject);
        }
    };

    const checkDeliveryService = (addressObject) => {
        let online_settings = Object.assign(
            [],
            props.delivery_pickup[0]?.location?.location_online_order_settings
        );
        if (online_settings.length > 0) {
            online_settings.map((location_settings) => {
                if (location_settings?.is_delivery == 1) {
                    if (location_settings?.delivery_zips?.length > 0) {
                        let findIndex =
                            location_settings?.delivery_zips?.findIndex(
                                (zips) =>
                                    zips.zipcode.toString() ==
                                    addressObject?.postal_code
                            );
                        if (findIndex !== -1 && findIndex >= 0) {
                            setErrorMessage("");
                        } else {
                            setErrorMessage(Constants.OUT_OF_DELIVERY_AREA);
                        }
                    }
                } else {
                    setErrorMessage(
                        Constants.DELIVERY_SERVICE_NOT_AVAILABLE_LOCATION
                    );
                }
            });
        }
    };

    const handleSelectedScheduleType = (value) => {
        setSelectedScheduleType(value);
        setStateData((prevState) => ({ ...prevState, scheduled_type: value }));
        setSelectedTimeSlot("");
        if (value == "asap") {
            setStateData((prevState) => ({ ...prevState, deliveryTime: "" }));
            const asapSlot = timeSlot.find(
                (slot) => slot.id == stateData.asapTimeSlot
            );
            setAsapTime(asapSlot.time.split(" - ")[0].trim());
        }
    };

    const handleSelectedAddress = (addressObject) => {
        setAddress(addressObject);
        let googleAddressObj = Object.assign({}, addressObject.value);
        setGoogleDeliveryAddress(googleAddressObj);
        addressObject.place_id = addressObject?.value?.place_id;
        setSelectedPlaceId(addressObject?.place_id);
        checkDeliveryService(addressObject?.value);
    };

    const handleSelectedTimeSlot = (value) => {
        setSelectedTimeSlot(value);
        setStateData((prevState) => ({ ...prevState, deliveryTime: value }));
        setErrorMessage("");
    };

    const handleNextpage = () => {
        if (errorMessage.length > 0) {
            return;
        }
        if (orderType == "Delivery") {
            if (isDeliveryAddress) {
                if (address == null || address == undefined || address == "") {
                    setErrorMessage(
                        showNewAddressForm
                            ? Constants.DELIVERY_ADDRESS_REQUIRED
                            : Constants.SELECT_DELIVERY_ADDRESS
                    );
                    return;
                }
                setIsOrderTypeLayout(false);
                setSheduleTypeLayout(true);
                setIsDeliveryAddress(false);
            } else {
                let selectedAddress = alreadySavedAddresses.findIndex(
                    (item) =>
                        item?.place_id == props.delivery_pickup[0]?.place_id
                );
                if (selectedAddress >= 0) {
                    setSelectedPlaceId(
                        alreadySavedAddresses[selectedAddress]?.place_id
                    );
                    let addressObject = {
                        label: `${alreadySavedAddresses[selectedAddress].address}, ${alreadySavedAddresses[selectedAddress].city}, ${alreadySavedAddresses[selectedAddress].state} ${alreadySavedAddresses[selectedAddress].zipcode}`,
                        value: {
                            address:
                                alreadySavedAddresses[selectedAddress].address,
                            city: alreadySavedAddresses[selectedAddress].city,
                            state: alreadySavedAddresses[selectedAddress].state,
                            postal_code:
                                alreadySavedAddresses[selectedAddress].zipcode,
                            country:
                                alreadySavedAddresses[selectedAddress]
                                    .country || "US",
                            place_id:
                                alreadySavedAddresses[selectedAddress]
                                    ?.place_id,
                            default_selected: 1,
                        },
                    };
                    setAddress(addressObject);
                    let googleAddressObj = Object.assign(
                        {},
                        addressObject.value
                    );
                    setGoogleDeliveryAddress(googleAddressObj);
                }
                setIsOrderTypeLayout(false);
                setSheduleTypeLayout(false);
                setIsDeliveryAddress(true);
            }
        } else {
            setIsDeliveryAddress(false);
            setIsOrderTypeLayout(false);
            setSheduleTypeLayout(true);
        }
    };

    const getTimeSlot = () => {
        const locations =
            props.delivery_pickup.length > 0
                ? [props.delivery_pickup[0]?.location]
                : [];
        if (locations.length > 0) {
            for (const location of locations) {
                for (const online_settings of location.location_online_order_settings) {
                    const [hours, minutes, seconds] =
                        props.delivery_pickup[0]?.order_type === "pickup"
                            ? online_settings.pickup_lead_time.split(":")
                            : online_settings.delivery_lead_time.split(":");

                    const addTimeToday = moment()
                        .add(seconds, "seconds")
                        .add(minutes, "minutes")
                        .add(hours, "hours")
                        .format("ddd");

                    const finalTime = moment()
                        .add(seconds, "seconds")
                        .add(minutes, "minutes")
                        .add(hours, "hours")
                        .format("hh:mm A");

                    if (online_settings.location_hrs_sub_slot.length > 0) {
                        const currentTime = moment().format("hh:mm A");
                        const storeOpenTime =
                            online_settings.location_hrs_sub_slot[0].from_time;
                        const storeCloseTime =
                            online_settings.location_hrs_sub_slot[
                                online_settings.location_hrs_sub_slot.length - 1
                            ].to_time;
                        if (
                            moment(currentTime, ["h:mm A"]).isBefore(
                                moment(storeOpenTime, ["h:mm A"])
                            )
                        ) {
                            return online_settings.location_hrs_sub_slot[0];
                        } else if (
                            moment(currentTime, ["h:mm A"]).isAfter(
                                moment(storeCloseTime, ["h:mm A"])
                            )
                        ) {
                            return null;
                        } else {
                            if (
                                online_settings.location_hrs_sub_slot[0].day ===
                                addTimeToday.toUpperCase()
                            ) {
                                // Find first matching time slot
                                const matchingSlot =
                                    online_settings.location_hrs_sub_slot.find(
                                        (timeSlot) => {
                                            if (
                                                props.delivery_pickup[0]
                                                    ?.scheduleOrder ==
                                                    "custom" &&
                                                props.delivery_pickup[0]
                                                    ?.DeliveryTime?.id ==
                                                    timeSlot.id
                                            ) {
                                                return true;
                                            } else if (
                                                moment(timeSlot.from_time, [
                                                    "h:mm A",
                                                ]).isAfter(
                                                    moment(finalTime, [
                                                        "h:mm A",
                                                    ])
                                                )
                                            ) {
                                                if (
                                                    props.delivery_pickup[0]
                                                        ?.scheduleOrder ==
                                                    "asap"
                                                ) {
                                                    return true;
                                                }
                                            }
                                            return false;
                                        }
                                    );
                                return matchingSlot || null;
                            }
                        }
                    }
                }
            }
        }
        return null;
    };

    const handleTimeSlot = () => {
        if (errorMessage && errorMessage.length > 0) {
            return;
        }
        const locations = [props.delivery_pickup[0]?.location];
        if (locations.length > 0) {
            locations.forEach((location) => {
                location.location_online_order_settings.forEach(
                    (online_settings) => {
                        const [hours, minutes, seconds] =
                            orderType === "Pickup"
                                ? online_settings.pickup_lead_time.split(":")
                                : online_settings.delivery_lead_time.split(":");
                        const addTimeToday = moment()
                            .add(seconds, "seconds")
                            .add(minutes, "minutes")
                            .add(hours, "hours")
                            .format("ddd");
                        const finalTime = moment()
                            .add(seconds, "seconds")
                            .add(minutes, "minutes")
                            .add(hours, "hours")
                            .format("hh:mm A");
                        if (online_settings.location_hrs_sub_slot.length > 0) {
                            const currentTime = moment().format("hh:mm A");
                            const storeOpenTime =
                                online_settings.location_hrs_sub_slot[0]
                                    .from_time;
                            const storeCloseTime =
                                online_settings.location_hrs_sub_slot[
                                    online_settings.location_hrs_sub_slot
                                        .length - 1
                                ].to_time;
                            if (
                                moment(currentTime, ["h:mm A"]).isBefore(
                                    moment(storeOpenTime, ["h:mm A"])
                                )
                            ) {
                                setTimeSlot([]);
                                setErrorMessage(
                                    Constants.STORE_OPEN_BEFORE_ORDER_START
                                );
                            } else if (
                                moment(currentTime, ["h:mm A"]).isAfter(
                                    moment(storeCloseTime, ["h:mm A"])
                                )
                            ) {
                                setTimeSlot([]);
                                setErrorMessage(
                                    Constants.STORE_CLOSE_AFTER_ORDER_START
                                );
                            } else {
                                let storeTimeSlot = [];
                                let i = 1;
                                if (
                                    online_settings.location_hrs_sub_slot[0]
                                        .day === addTimeToday.toUpperCase()
                                ) {
                                    online_settings.location_hrs_sub_slot.forEach(
                                        (timeSlot) => {
                                            if (
                                                moment(timeSlot.from_time, [
                                                    "h:mm A",
                                                ]).isAfter(
                                                    moment(finalTime, [
                                                        "h:mm A",
                                                    ])
                                                )
                                            ) {
                                                if (i === 1) {
                                                    setStateData(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            asapTimeSlot:
                                                                timeSlot.id,
                                                        })
                                                    );
                                                    i = 0;
                                                }
                                                if (
                                                    props.delivery_pickup[0]
                                                        ?.scheduleOrder ==
                                                        "custom" &&
                                                    props.delivery_pickup[0]
                                                        ?.DeliveryTime?.id ==
                                                        timeSlot.id &&
                                                    props.delivery_pickup[0]?.order_type?.toUpperCase() ==
                                                        orderType.toUpperCase()
                                                ) {
                                                    setSelectedScheduleType(
                                                        "custom"
                                                    );
                                                    setSelectedTimeSlot({
                                                        id: timeSlot.id,
                                                        time: `${timeSlot.from_time} - ${timeSlot.to_time}`,
                                                    });
                                                } else if (
                                                    props.delivery_pickup[0]
                                                        ?.scheduleOrder ==
                                                        "custom" &&
                                                    props.delivery_pickup[0]?.order_type?.toUpperCase() ==
                                                        orderType.toUpperCase()
                                                ) {
                                                    setSelectedScheduleType(
                                                        "custom"
                                                    );
                                                }
                                                storeTimeSlot.push({
                                                    id: timeSlot.id,
                                                    time: `${timeSlot.from_time} - ${timeSlot.to_time}`,
                                                });
                                            }
                                        }
                                    );
                                    if (storeTimeSlot.length > 0) {
                                        setAsapTime(
                                            storeTimeSlot[0].time
                                                .split(" - ")[0]
                                                .trim()
                                        );
                                        // setErrorMessage("");
                                        setTimeSlot(storeTimeSlot);
                                        handleNextpage();
                                    } else {
                                        setTimeSlot([]);
                                        setErrorMessage(
                                            Constants.PICKUP_TIME_SLOTE_NOT_FOUND
                                        );
                                    }
                                } else {
                                    setTimeSlot([]);
                                    setErrorMessage(
                                        Constants.DAY_CHANGE_TIME_SLOTE_NOT_AVAILABLE
                                    );
                                }
                            }
                        }
                    }
                );
            });
        }
    };

    const handleModalClose = () => {
        onClose();
        setIsOrderTypeLayout(true);
        setSheduleTypeLayout(false);
        setIsDeliveryAddress(false);
        orderInstructionFormik.resetForm();
        setStateData((prevState) => ({
            ...prevState,
            saveDeliveryAddress: false,
        }));
    };

    const handleSubmit = () => {
        const orderDetails = {
            order_type: orderType.toLowerCase(),
            location: props.delivery_pickup[0]?.location,
            address:
                orderType === "Delivery"
                    ? googleDeliveryAddress?.address
                    : props.delivery_pickup[0]?.address,
            city:
                orderType === "Delivery"
                    ? googleDeliveryAddress?.city
                    : props.delivery_pickup[0]?.city,
            state:
                orderType === "Delivery"
                    ? googleDeliveryAddress?.state
                    : props.delivery_pickup[0]?.state,
            zipCode:
                orderType === "Delivery"
                    ? googleDeliveryAddress?.postal_code
                    : props.delivery_pickup[0]?.zipCode,
            country:
                orderType === "Delivery"
                    ? googleDeliveryAddress?.country
                    : props.delivery_pickup[0]?.country,
            scheduleOrder: selectedScheduleType,
            DeliveryTime: selectedTimeSlot,
            place_id:
                orderType === "Delivery" ? googleDeliveryAddress?.place_id : "",
        };
        props.addDeliveryPickupDetails(orderDetails);
        orderType === "Delivery" && orderInstructionFormik.handleSubmit();
        setOrderType("");
        setSelectedScheduleType("asap");
        setSelectedTimeSlot("");
        setErrorMessage("");
        setAddress(null);
        setGoogleDeliveryAddress(null);
        setIsDeliveryAddress(false);
        setIsOrderTypeLayout(true);
        setSheduleTypeLayout(false);
        if (orderType === "Delivery") {
            setStateData((prevState) => ({
                ...prevState,
                saveDeliveryAddress: false,
            }));
        }
        setIsLoading(false);
        onClose();
    };

    const handleCheckSaveDeliveryAddress = () => {
        if (
            (selectedTimeSlot == null ||
                selectedTimeSlot == undefined ||
                selectedTimeSlot == "") &&
            selectedScheduleType == "custom"
        ) {
            setErrorMessage(
                orderType === "Delivery"
                    ? Constants.DELIVERY_TIME_SELECT_ERROR
                    : Constants.PICKUP_TIME_SELECT_ERROR
            );
            return;
        }
        setIsLoading(true);
        if (
            orderType === "Delivery" &&
            stateData.saveDeliveryAddress &&
            googleDeliveryAddress?.place_id
        ) {
            saveDeliveryAddressForFutureOrder(googleDeliveryAddress)
                .then((res) => {
                    if (res.error) {
                        const { status, data } = res.response;
                        if (status === Constants.UNAUTHORIZE_CODE) {
                            handleSignInRequired();
                            data.message =
                                Constants.LOGIN_REQUIRED_TO_SAVE_DELIVERY_ADDRESS;
                            setIsLoading(false);
                        } else if (status === Constants.NOT_FOUND_ERROR) {
                            setIsLoading(false);
                        } else {
                            let popupError = error({ actionData: res });
                            if (
                                popupError?.message?.length > 0 &&
                                popupError?.message == "Address already exists."
                            ) {
                                handleSubmit();
                            } else {
                                if (popupError?.error) {
                                    setServerPayload(popupError);
                                    setTimeout(() => {
                                        setServerPayload({});
                                    }, 5000);
                                }
                                setIsLoading(false);
                                setShowNewAddressForm(false);
                            }
                        }
                    } else if (res.data.flag) {
                        setShowNewAddressForm(false);
                        handleSubmit();
                    } else {
                        error({ actionData: res.response.data });
                        setIsLoading(false);
                    }
                })
                .catch((err) => {
                    const popupError = error({ actionData: err });
                    setIsLoading(false);
                    setShowNewAddressForm(false);
                    if (popupError?.error) {
                        setServerPayload(popupError);
                        setTimeout(() => {
                            setServerPayload({});
                        }, 5000);
                    }
                });
        } else {
            handleSubmit();
        }
    };

    const handleSignInRequired = () => {
        // Temporarily disable focus trap on gift card modal
        // Add a small delay before opening the sign-in modal
        setTimeout(() => {
            setModalOpen(true);
        }, 100);
    };

    const handlePreviousPage = () => {
        if (isDeliveryAddress) {
            setIsOrderTypeLayout(true);
            setSheduleTypeLayout(false);
            setIsDeliveryAddress(false);
            setErrorMessage("");
            setAddress(null);
            setGoogleDeliveryAddress(null);
        } else if (sheduleTypeLayout) {
            setIsOrderTypeLayout(orderType !== "Delivery");
            setSheduleTypeLayout(false);
            setIsDeliveryAddress(orderType === "Delivery");
            setErrorMessage("");
            setSelectedScheduleType(props.delivery_pickup[0]?.scheduleOrder);
            setSelectedTimeSlot(
                props.delivery_pickup[0]?.scheduleOrder === "custom"
                    ? props.delivery_pickup[0]?.DeliveryTime
                    : ""
            );
        }
    };

    const handleToggleNewAddressForm = (flag) => {
        setShowNewAddressForm(flag);
        setGoogleDeliveryAddress(null);
        setErrorMessage("");
        setAddress(null);
        setSelectedPlaceId(null);
        setStateData((prevState) => ({
            ...prevState,
            saveDeliveryAddress: false,
        }));
    };

    const handleSaveDeliveryAddress = (checked) => {
        setStateData((prevState) => ({
            ...prevState,
            saveDeliveryAddress: checked,
        }));
    };

    return {
        isOpen,
        isMobile,
        myContext,
        isLarge,
        isMedium,
        selectedScheduleOptions,
        options,
        group,
        open,
        menuOpen,
        id,
        isModalOpen,
        anchorEl,
        isGiftCardModalOpen,
        orderType,
        errorMessage,
        isOrderTypeLayout,
        isDeliveryAddress,
        address,
        sheduleTypeLayout,
        timeSlot,
        selectedTimeSlot,
        selectedScheduleType,
        stateData,
        asapTime,
        popoverOpen,
        alreadySavedAddresses,
        selectedPlaceId,
        showNewAddressForm,
        orderInstructionFormik,
        isSignInModalOpen,
        serverPayload,
        isLoading,
        isSmall,
        getRadioProps,
        handleClick,
        handleClose,
        handleOpenModal,
        handleCloseModal,
        handleMenuClick,
        handleOrderHistoryClick,
        handleGiftCardClick,
        handleSetDelivery,
        handleSelectedScheduleType,
        handleSelectedTimeSlot,
        handleTimeSlot,
        handleModalClose,
        handleChangeDeliveryPickup,
        handlePreviousPage,
        handleToggleNewAddressForm,
        handleSelectedAddress,
        handleSaveDeliveryAddress,
        handleCheckSaveDeliveryAddress,
        getTimeSlot,
        handleProfileClick,
    };
};

export default useHeader;
